// add a class .collapse-lock-screen for the toggled element to make it lock the screen using bootstraps
// collapse
const LOCK = 'modal-open';
const REQUIRES_LOCK = 'collapse-lock-screen';

const lockScreenOnToggle = () => {
    $(document).on('show.bs.collapse hidden.bs.collapse', e => {
        if (e.target instanceof HTMLElement && e.target.classList.contains(REQUIRES_LOCK) && e.type === 'show') {
            document.body.classList.add(LOCK);
        } else {
            document.body.classList.remove(LOCK);
        }
    });
}

export default lockScreenOnToggle;
